import { render } from "./ScopeFilterDropdown.vue?vue&type=template&id=0bee6a83&scoped=true&ts=true"
import script from "./ScopeFilterDropdown.vue?vue&type=script&lang=ts"
export * from "./ScopeFilterDropdown.vue?vue&type=script&lang=ts"

import "./ScopeFilterDropdown.vue?vue&type=style&index=0&id=0bee6a83&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bee6a83"]])

export default __exports__